import { render, staticRenderFns } from "./ct-button.vue?vue&type=template&id=8ffecb24"
import script from "./ct-button.vue?vue&type=script&lang=js"
export * from "./ct-button.vue?vue&type=script&lang=js"
import style0 from "./ct-button.vue?vue&type=style&index=0&id=8ffecb24&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports